const Strings = {
  MY_INFORMATION: {
    SE: 'Mina uppgifter',
    EN: 'My information'
  },
  APARTMENT: {
    SE: 'Lägenhetsnummer',
    EN: 'Apartment number'
  },
  EMAIL: {
    SE: 'Email',
    EN: 'Email'
  },
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  ASSOCIATION: {
    SE: 'Förening',
    EN: 'Association'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/SettingsTable/strings.js